var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.sessionExpiring)?_c('div',{staticClass:"alert alert--danger"},[_c('div',[_c('div',[_c('p',[_vm._v("Automatic Logout In "+_vm._s(_vm.time))])]),_vm._v(" "),_c('div',[_c('process-button',{staticClass:"button button--negative--small",attrs:{"processing":_vm.refreshing,"text":"Cancel Logout"},on:{"click":_vm.refresh}})],1)])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }